var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import Select from 'react-select';
import { Button, Input } from '../Forms/Fields';
import toast from '../Toast';
import { FilterBody, FilterSelectContainer, FilterContainer, ButtonContainer, } from './styles';
export var FilterPopover = function (_a) {
    var filterTypes = _a.filterTypes, _b = _a.columns, columns = _b === void 0 ? [] : _b, hideFilterPopover = _a.hideFilterPopover, applyFilters = _a.applyFilters, disablePopup = _a.disablePopup, isRule = _a.isRule;
    var _c = useState(null), selectedColumn = _c[0], setSelectedColumn = _c[1];
    var _d = useState(null), selectedFilterType = _d[0], setSelectedFilterType = _d[1];
    var _e = useState(''), value = _e[0], setValue = _e[1];
    var _f = useState(filterTypes.map(function (option) { return ({
        value: option,
        label: option.name,
        accepts: option.accepts || null,
    }); })), filterOptions = _f[0], setFilterOptions = _f[1];
    var selectColumn = function (column) {
        setSelectedColumn(column.value);
        var newOptions = filterTypes
            .filter(function (t) { return t.accepts.includes(column.type); })
            .map(function (option) { return ({
            value: option,
            label: option.name,
            accepts: option.accepts || null,
        }); });
        setFilterOptions(newOptions);
        setSelectedFilterType(null);
    };
    var selectFilterType = function (filterType) {
        setSelectedFilterType(filterType.value);
    };
    var handleValueChange = function (event) {
        var target = event.target;
        setValue(target.value);
    };
    var filterValues = function () {
        if (!selectedColumn || !selectedFilterType) {
            toast.error('Please select column name and filter type');
            return;
        }
        if ((selectedFilterType === null || selectedFilterType === void 0 ? void 0 : selectedFilterType.operation) === 'null') {
            applyFilters(selectedColumn, selectedFilterType, 'null');
        }
        else if ((selectedFilterType === null || selectedFilterType === void 0 ? void 0 : selectedFilterType.operation) === 'nnull') {
            applyFilters(selectedColumn, selectedFilterType, 'nnull');
        }
        else {
            applyFilters(selectedColumn, selectedFilterType, value);
        }
        setSelectedColumn('');
        setSelectedFilterType('');
        setValue('');
    };
    var columnOptions = columns
        .filter(function (option) { return !option.tableColumn; })
        .map(function (option) { return ({
        value: option.name,
        label: option.display || option.name,
        type: option.type,
    }); });
    return (_jsxs(FilterContainer, __assign({ disablePopup: disablePopup }, { children: [_jsxs(FilterBody, { children: [_jsx(FilterSelectContainer, { children: _jsx(Select, { onChange: selectColumn, placeholder: "Column", value: columnOptions.find(function (column) { return column.value === selectedColumn; }) ||
                                null, options: columnOptions, maxMenuHeight: isRule && 130 }) }), _jsx(FilterSelectContainer, { children: _jsx(Select, { onChange: selectFilterType, placeholder: "Filter type", value: filterOptions.find(function (filter) {
                                return selectedFilterType &&
                                    filter.value.name === selectedFilterType.name;
                            }) || null, options: filterOptions, maxMenuHeight: isRule && 130 }) }), !((selectedFilterType === null || selectedFilterType === void 0 ? void 0 : selectedFilterType.operation) === 'null' ||
                        (selectedFilterType === null || selectedFilterType === void 0 ? void 0 : selectedFilterType.operation) === 'nnull') && (_jsx(Input, { placeholder: "Value", name: "value", type: "text", value: value, style: { width: '190px', margin: 0 }, onChange: handleValueChange }))] }), _jsxs(ButtonContainer, { children: [_jsx(Button, __assign({ style: { marginBottom: 0 }, subdued: true, small: true, onClick: hideFilterPopover }, { children: "Cancel" })), _jsx(Button, __assign({ style: { marginBottom: 0 }, primary: true, small: true, marginLeft: true, disabled: !selectedColumn ||
                            !selectedFilterType ||
                            (!((selectedFilterType === null || selectedFilterType === void 0 ? void 0 : selectedFilterType.operation) === 'null' ||
                                (selectedFilterType === null || selectedFilterType === void 0 ? void 0 : selectedFilterType.operation) === 'nnull') &&
                                !value), onClick: filterValues }, { children: "Apply" }))] })] })));
};
FilterPopover.defaultProps = {
    isRule: false,
};
export default FilterPopover;
